import { render, staticRenderFns } from "./MySandglass.vue?vue&type=template&id=17b5f8f1&scoped=true"
import script from "./MySandglass.vue?vue&type=script&lang=js"
export * from "./MySandglass.vue?vue&type=script&lang=js"
import style0 from "./MySandglass.vue?vue&type=style&index=0&id=17b5f8f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b5f8f1",
  null
  
)

export default component.exports